import { ModelBase } from '../../core/model/model-base';
import { ObjectComponentType } from '../../rent/model/object-component-type';
import { ArticleUnit, ArticleUnitKindToString } from '../../rent/model/const/enums';
import { Money } from '../../core/model/money';

export class PriceListItemCoding extends ModelBase {
  accountPlanId: string;
  incomeAccountId: string;
  accountPlanName: string;
  costPlace: string;
  function: string;
}

export class PriceListItem extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.code = dataContext.code;
      this.name = dataContext.name;
      this.amount = dataContext.amount;
      this.componentType = dataContext.componentType;
      this.componentTypeName = dataContext.componentTypeName;
      this.componentCategory = dataContext.componentCategory;
      this.componentCategoryName = dataContext.componentCategoryName;
      this.customProperty = dataContext.customProperty;
      this.startCost = dataContext.startCost;
      this.unit = dataContext.unit;
      this.vatPercent = dataContext.vatPercent;
      this.codings = Array.isArray(dataContext.codings) ? dataContext.codings : [];
      this.currencyCode = dataContext.currencyCode;
      this.priceListId = dataContext.priceListId;
    }
  }

  codings: PriceListItemCoding[] = [];
  amount: Money = null;
  code: string;
  componentCategory: string = null;
  componentType: string = null;
  componentTypeName: string;
  componentCategoryName: string;
  currencyCode: string;
  customProperty: string = null;
  name: string;
  startCost: Money = null;
  unit = ArticleUnit.None;
  priceListId: string;
  get unitCaption(): string {
    return ArticleUnitKindToString(this.unit);
  }
  vatPercent = 0;

  toJSON() {
    return this;
  }

  toString(): string {
    return (this.code ? this.code + ', ' : '') + (this.name ? this.name : '');
  }
}
